import { render } from "./posturalFormulario.vue?vue&type=template&id=0c2da5ba&scoped=true"
import script from "./posturalFormulario.vue?vue&type=script&lang=js"
export * from "./posturalFormulario.vue?vue&type=script&lang=js"

import "./posturalFormulario.vue?vue&type=style&index=0&id=0c2da5ba&scoped=true&lang=css"

import exportComponent from "E:\\LARAVEL\\diariodetreino pastas\\front\\diariodetreino-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c2da5ba"]])

export default __exports__